import { useEffect, useState } from 'react';
import {
  LOADING_START_EVENT,
  LOADING_STOP_EVENT
} from '../Utility Components/loadingEvents';

const LOADING_DELAY_MS = 140;

function GlobalLoadingOverlay() {
  const [pendingCount, setPendingCount] = useState(0);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleStart = () => setPendingCount((count) => count + 1);
    const handleStop = () => setPendingCount((count) => Math.max(count - 1, 0));

    window.addEventListener(LOADING_START_EVENT, handleStart);
    window.addEventListener(LOADING_STOP_EVENT, handleStop);

    return () => {
      window.removeEventListener(LOADING_START_EVENT, handleStart);
      window.removeEventListener(LOADING_STOP_EVENT, handleStop);
    };
  }, []);

  useEffect(() => {
    if (pendingCount > 0) {
      const timerId = window.setTimeout(() => setVisible(true), LOADING_DELAY_MS);
      return () => window.clearTimeout(timerId);
    }

    setVisible(false);
    return undefined;
  }, [pendingCount]);

  if (!visible) {
    return null;
  }

  return (
    <div className="global-loading-overlay" role="status" aria-live="polite" aria-label="Loading">
      <div className="global-loading-overlay__panel">
        <span className="global-loading-overlay__spinner" aria-hidden="true" />
        <span>Loading</span>
      </div>
    </div>
  );
}

export default GlobalLoadingOverlay;
